<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <div class="title">
            프로필 테두리 {{ p_idx ? '수정' : '발급' }}
            <div class="clear"></div>
          </div>
          <div class="c_table_wrap">
            <table>
              <colgroup>
                <col width="200px;">
                <col width="">
                <col width="200px;">
                <col width="">
              </colgroup>
              <tr>
                <td class="c_t_title">이름</td>
                <td>
                  <div>
                    <el-input v-model="p_title"></el-input>
                    <div class="input_error">{{validation.firstError('p_title') }}</div>
                    <div></div>
                  </div>
                </td>
                <td class="c_t_title">노출상태</td>
                <td>
                  <div>
                      <el-radio-group v-model="p_is_display">
                        <el-radio :label="1">노출</el-radio>
                        <el-radio :label="false">노출중지</el-radio>
                      </el-radio-group>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="c_t_title">사진</td>
                <td colspan="3">
                  <div @click="UploadFlagChange('profileOutline')" class="stori_title">
                    <el-upload
                            ref="profileOutline"
                            class="avatar-uploader magazine_title"
                            action=""
                            list-type="picture-card"
                            :auto-upload="false"
                            :show-file-list="false"
                            :file-list="profileOutline"
                            :on-exceed="handleFileExceed"
                            :on-change="handleFileChange"
                            :on-remove="handlefileRemove"
                    >
                      <i class="el-icon-plus avatar-uploader-icon" v-if="profileOutline.length === 0"></i>
                      <div v-else>
                        <img :src="profileOutline[0].url" alt="" class="avatar">
                      </div>
                      <div class="el-upload__tip" style="font-size:14px; color:red;" slot="tip">권장이미지 :  *px * *px</div>
                    </el-upload>
                    <div class="input_error">{{validation.firstError('profileOutline') }}</div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="text_center mt15">
            <el-button type="primary" @click="submitForm('ruleForm')">저장</el-button>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
    import VuxAlert from '@/mixins/vux-alert';
    import util from '@/mixins/util';
    import localStorage from '@/mixins/localStorage'


    let params = {};
    export default {
        name: 'ProfileBorderDetail',
        components: {
        },
        mixins: [ VuxAlert ,localStorage ],
        data() {
            return{
                title: this.$route.meta.title,
                p_idx : this.$route.params.p_idx,
            }
        },
        mounted() {
            this.getDetail();
        },
        beforeRouteLeave(to, from, next){
            if(to.path === "/auth" && this.$localStorage.get('token')){
                next(false);
            }else{
                return next();
            }
        },
        watch: {

        },
        created() {
        },
        methods: {
            getDetail() {
                if(this.p_idx) {
                    let params = {
                        pt : 'member',
                        id : this.p_idx
                    }
                    this.$api.$member.getProfile(params).then( res => res.Data.Result).then(res => {
                        if(!util.isEmpty(res.List)){
                            this.p_title = res.List[0].p_title;
                            this.p_is_display = res.List[0].p_is_display;
                            res.List[0].File[0].url = res.List[0].File[0].org_url;
                            this.profileOutline.push(res.List[0].File[0]);
                        }
                    });
                }
            },
            submitForm(formName) {
                let validationArray = ['p_title','profileOutline'];
                this.$validate(validationArray).then(async (success) => {
                        if(success) {
                            let params = {
                                p_type: 'member',
                                p_title :this.p_title,
                                p_is_display: this.p_is_display,
                            }
                            if(this.p_idx){
                                params.p_idx = this.p_idx;
                                this.$api.$member.updateProfile(params).then( res => res.Data.Result).then(res => {
                                    if(res.Info.status){
                                        if(this.deleteProfileOutline.length > 0) {
                                            this.deleteFile();
                                        }
                                        if(this.profileOutline[0].hasOwnProperty('raw')) {
                                            this.uploadFile(this.profileOutline, 'profileOutline', res.List);
                                        }else{
                                            let alertParams = { element: this, title: '확인', content: '수정완료', btnText: '확인'}
                                            this.historyBackAlert(alertParams);
                                        }
                                    }else{
                                        let failMsg = '수정 실패';
                                        if(res.Info.reason === 100){
                                            failMsg = '잘못된 데이터입니다.';
                                        }
                                        this.errorAlert(failMsg);
                                    }
                                })
                            }else{
                                this.$api.$member.createProfile(params).then( res => res.Data.Result).then(res => {
                                    if(res.Info.status){
                                        if(this.profileOutline[0].hasOwnProperty('raw')) {
                                            this.uploadFile(this.profileOutline, 'profileOutline', res.List);
                                        }else{
                                            let alertParams = { element: this, title: '확인', content: '등록완료', btnText: '확인'}
                                            this.historyBackAlert(alertParams);
                                        }
                                    }else{
                                        let failMsg = '등록 실패';
                                        this.errorAlert(failMsg);
                                    }
                                })
                            }
                        }else{
                            this.errorAlert('입력값을 확인해주세요.')
                        }
                });
            },
            handleFileExceed() {
                this.errorAlert('1개만 업로드 가능합니다.');
            },
            handleFileChange(file, fileList) {
                let maxSize = 1024 * 1024 * 20;
                let type = file.raw.type.split('/');
                if(file.size > maxSize) {
                    this.errorAlert('1회 업로드 가능 용량을 초과했습니다!');
                    fileList.pop();
                }else if(!(type[1] === 'jpeg' || type[1] === 'png')) {
                    this.errorAlert('이미지 파일만 업로드 가능합니다.')
                    fileList.pop();
                }else{
                    this.MoveFileList(file)
                }
            },
            UploadFlagChange(flag) {
                this.UploadFlag = flag
            },
            MoveFileList(file) {
                switch(this.UploadFlag) {
                    case 'profileOutline':
                        if(this.profileOutline.length > 0 && this.profileOutline[0].hasOwnProperty('a_idx')) {
                            file.a_idx = this.profileOutline[0].a_idx;
                        }
                        this.profileOutline[0] = file;
                        this.$forceUpdate();
                        break;
                }

            },
            handlefileRemove(file, fileList) {
                if(file.a_idx) {
                    this.deleteProfileOutline.push(file);
                }
                this.File = [];
            },
            uploadFile(fileList, type, id ) {
                let formData = new FormData;
                formData.append('files', fileList[0].raw);
                formData.append('a_container_type', type);
                formData.append('a_container_id', id);
                if(fileList[0].a_idx) {
                    formData.append('a_idx', fileList[0].a_idx);
                }
                return this.$api.$common.updateFile(formData).then( res => res.Data.Result).then(res => {
                    if(res.Info.status){
                        fileList[0].a_idx = res.List;
                        this.profileOutline = fileList;
                        let text = this.title;
                        let alertParams = { element: this, title: '확인', content: text+'완료', btnText: '확인'}
                        this.historyBackAlert(alertParams);
                    }else{
                        this.errorAlert("사진 등록에 실패했습니다.");
                    }
                })
            },
            deleteFile() {
                let list = this.deleteProfileOutline.slice();
                return list.forEach(file => {
                    let params = {
                        a_idx : file.a_idx
                    };
                    this.$api.$file.deleteFile(params).then(() => {
                        this.deleteProfileOutline.splice(0, 1);
                    });
                })
            },
        }
    }
</script>
